/**
 * PORTED — RO-3-03 / #44296.
 * Origin: `excellent/app/suggestions/suggestions-live.tsx` (verbatim, minus the
 * inert `"use client"`). `suggestions.list` is mounted on the Hono host.
 *
 * Same seed caveat as ActivityLive: without SSR the first paint is unseeded
 * until SWR returns. Callers pass `seed={[]}` and accept a one-frame empty
 * state, or gate on isLoading at the page layer.
 */

import { Card, SuggestionCard } from "@excellent/ui";
import { useLiveResource } from "@excellent/ui/api/live";
import {
  suggestions,
  type SuggestionItem,
} from "@excellent/ui/api/contracts/suggestions";

export function SuggestionsLive({ seed }: { seed: SuggestionItem[] }) {
  const { data } = useLiveResource(suggestions.list, {}, {
    topic: "suggestions",
    seed: { attention: seed },
    refreshInterval: 60_000,
  });
  const attention = data?.attention ?? seed;

  if (attention.length === 0) {
    return (
      <Card className="p-6">
        <p className="type-body text-muted-foreground">
          Nothing needs attention. Your workspace is clear.
        </p>
      </Card>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {attention.map((item, i) => {
        const body = (
          <div className="flex min-w-0 flex-col gap-0.5 p-4">
            <span className="type-body text-foreground leading-ui">
              {item.title}
            </span>
            {item.body ? (
              <span className="type-subtext text-muted-foreground leading-ui">
                {item.body}
              </span>
            ) : null}
          </div>
        );
        return (
          <SuggestionCard key={`${item.title}-${i}`} href={item.href}>
            {body}
          </SuggestionCard>
        );
      })}
    </div>
  );
}
